module.exports = { URL: window.URL, URLSearchParams: window.URLSearchParams, __from: __filename };
